import { InputNumber } from "antd"
import style from "./DimensionsSection.module.scss"

const { section, sectionTitle, inputs, input, labelRow, label, requiredMark, lnftHint, numberInput } = style

type Props = {
	width: number | null
	height: number | null
	depth: number | null
	onWidthChange: (value: number | null) => void
	onHeightChange: (value: number | null) => void
	onDepthChange: (value: number | null) => void
	onWidthCommit?: () => void
	onHeightCommit?: () => void
	onDepthCommit?: () => void
	isRequired?: boolean
}

const toLnFt = (inches: number | null): string | null => {
	if (inches === null || Number.isNaN(inches)) return null
	return `${Math.round(inches / 12)} LnFt`
}

export const DimensionsSection = ({
	width,
	height,
	depth,
	onWidthChange,
	onHeightChange,
	onDepthChange,
	onWidthCommit,
	onHeightCommit,
	onDepthCommit,
	isRequired = true,
}: Props) => {
	const widthLnFt = toLnFt(width)

	return (
		<div className={section}>
			<p className={sectionTitle}>Dimensions</p>
			<div className={inputs}>
				<div className={input}>
					<div className={labelRow}>
						<span className={label}>Width</span>
						{isRequired ? <span className={requiredMark}>*</span> : null}
					</div>
					<InputNumber
						className={numberInput}
						value={width}
						onChange={(v) => onWidthChange(typeof v === "number" ? v : null)}
						onBlur={onWidthCommit}
						onPressEnter={onWidthCommit}
						suffix="in"
						controls={false}
						min={0}
					/>
					{widthLnFt ? <span className={lnftHint}>{widthLnFt}</span> : null}
				</div>
				<div className={input}>
					<div className={labelRow}>
						<span className={label}>Height</span>
						{isRequired ? <span className={requiredMark}>*</span> : null}
					</div>
					<InputNumber
						className={numberInput}
						value={height}
						onChange={(v) => onHeightChange(typeof v === "number" ? v : null)}
						onBlur={onHeightCommit}
						onPressEnter={onHeightCommit}
						suffix="in"
						controls={false}
						min={0}
					/>
				</div>
				<div className={input}>
					<div className={labelRow}>
						<span className={label}>Depth</span>
						{isRequired ? <span className={requiredMark}>*</span> : null}
					</div>
					<InputNumber
						className={numberInput}
						value={depth}
						onChange={(v) => onDepthChange(typeof v === "number" ? v : null)}
						onBlur={onDepthCommit}
						onPressEnter={onDepthCommit}
						suffix="in"
						controls={false}
						min={0}
					/>
				</div>
			</div>
		</div>
	)
}
